import { css } from 'aphrodite';
import { rendererContainer, field, fieldReadOnly } from './styles/commonRendererStyles';
import type { AutomationStepNodeData } from '../../types/stepNodes';

interface NoActionStepRendererProps {
	nodeId: string;
	data: AutomationStepNodeData;
	readOnly?: boolean;
}

export function NoActionStepRenderer(_props: NoActionStepRendererProps) {
	return (
		<div className={css(rendererContainer)}>
			<div style={{ marginBottom: 4, fontSize: 14, color: '#4A4A4A' }}>Take no action.</div>
			<div
				className={css(field, fieldReadOnly)}
				style={{
					marginTop: 8,
					fontSize: 13,
					color: '#6B7280',
					fontStyle: 'italic',
				}}
			>
				This step does nothing and ends this branch of the automation.
			</div>
		</div>
	);
}
